import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { message, Modal } from 'antd';
import { Document, Page, pdfjs } from 'react-pdf';
import VisibilitySensor from 'react-visibility-sensor';
import { IMAGE_TYPE, PDF_TYPE, AUDIO_TYPE, VIDEO_TYPE, UNSUPPORTED, IS_IMAGE_REGEX, IS_PDF_REGEX, IS_AUDIO_REGEX, IS_VIDEO_REGEX } from './constants';
import './Preview.Modal.scss';
pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.js");
const fileType = url => {
  if (url.match(IS_IMAGE_REGEX)) {
    return IMAGE_TYPE;
  }
  if (url.match(IS_PDF_REGEX)) {
    return PDF_TYPE;
  }
  if (url.match(IS_AUDIO_REGEX)) {
    return AUDIO_TYPE;
  }
  if (url.match(IS_VIDEO_REGEX)) {
    return VIDEO_TYPE;
  }
  return '';
};
const getFileType = url => url ? url.split('.').pop() : '';
class PreviewModal extends Component {
  constructor(_props) {
    super(_props);
    this.customErrorComponent = () => /*#__PURE__*/React.createElement("span", null, "Preview not supported for file format");
    this.turnPage = addPage => {
      const {
        pageNumber
      } = this.state;
      this.setState({
        pageNumber: pageNumber + addPage
      });
    };
    this.renderPDF = (numPages, pageNumber, previewItemURL, pageList, hasMore) => /*#__PURE__*/React.createElement("div", {
      className: "pdfWrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "documentWrapper"
    }, /*#__PURE__*/React.createElement(Document, {
      file: previewItemURL,
      onLoadSuccess: props => this.onDocumentLoadSuccess(props),
      loading: __("Loading PDF...")
    }, !_isEmpty(pageList) && pageList.map(pageNum => /*#__PURE__*/React.createElement(Page, {
      key: pageNum,
      pageNumber: pageNum,
      wrap: false
    }))), /*#__PURE__*/React.createElement(VisibilitySensor, {
      onChange: isVisible => this.onDocumentEnd(isVisible),
      intervalDelay: 1000,
      scrollDelay: 1000
    }, /*#__PURE__*/React.createElement("div", null, hasMore ? /*#__PURE__*/React.createElement("div", {
      className: "pdf-loader"
    }, " ", __('Loading...')) : /*#__PURE__*/React.createElement("div", null)))));
    this.renderAudio = (file, name) => /*#__PURE__*/React.createElement("div", {
      className: "audiowrapper"
    }, /*#__PURE__*/React.createElement("audio", {
      controls: true
    }, /*#__PURE__*/React.createElement("source", {
      src: file,
      type: "audio/".concat(getFileType(name))
    }), /*#__PURE__*/React.createElement("p", null, __('Audio format not supported'))));
    this.renderVideo = file => /*#__PURE__*/React.createElement("div", {
      className: "videoWrapper"
    }, /*#__PURE__*/React.createElement("video", {
      controls: true
    }, /*#__PURE__*/React.createElement("track", {
      kind: "captions"
    }), /*#__PURE__*/React.createElement("source", {
      src: file
    }), /*#__PURE__*/React.createElement("p", null, __('Video format not supported'))));
    this.renderUnsupported = () => /*#__PURE__*/React.createElement("div", {
      className: "unsupported"
    }, __('Unsupported file format'));
    this.state = {
      numPages: 0,
      pageNumber: 1,
      pageList: []
    };
  }
  onError(e) {
    message.alert(e, __('error in file-viewer'));
  }
  onDocumentLoadSuccess(_ref) {
    let {
      numPages
    } = _ref;
    this.setState({
      numPages,
      pageList: [1]
    });
  }
  onDocumentEnd(isVisible) {
    if (!isVisible) {
      return;
    }
    const {
      pageList,
      numPages
    } = this.state;
    if (pageList.length === numPages) {
      return;
    }
    pageList.push(pageList.length + 1);
    this.setState({
      pageList
    });
  }
  render() {
    const {
      name,
      url,
      onClose
    } = this.props;
    const {
      pageNumber,
      numPages,
      pageList
    } = this.state;
    const hasMore = numPages > pageList.length;
    const fileTypeName = fileType(name) || fileType(url) || UNSUPPORTED;
    const displayName = decodeURI(name || '');
    return /*#__PURE__*/React.createElement(Modal, {
      visible: true,
      title: displayName,
      centered: true,
      footer: null,
      destroyOnClose: true,
      width: "75%",
      bodyStyle: {
        maxHeight: '80vh',
        overflow: 'scroll'
      },
      onCancel: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "tap-editor-preview"
    }, fileTypeName === IMAGE_TYPE && /*#__PURE__*/React.createElement("img", {
      src: url,
      alt: displayName
    }), fileTypeName === PDF_TYPE && this.renderPDF(numPages, pageNumber, url, pageList, hasMore), fileTypeName === AUDIO_TYPE && this.renderAudio(url, displayName || url), fileTypeName === VIDEO_TYPE && this.renderVideo(url), fileTypeName === UNSUPPORTED && this.renderUnsupported()));
  }
}
PreviewModal.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string,
  onClose: PropTypes.func
};
PreviewModal.defaultProps = {
  name: '',
  onClose: null
};
export default PreviewModal;